import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { Header, Content, ContentsWrapper } from '../../../common/ModalBlocks';
import CertificationIcon from './Certificate.svg';

import classes from './index.module.scss';

const T_KEY = 'freelancer_page.modal.certifications';

/** @type {import('./index').Certifications} */
export const Certifications = ({ certifications = [] }) => (
    <div className={classes.wrapper}>
        <Header title={<I18n k={`${T_KEY}.title`} />} />
        <ContentsWrapper>
            {certifications.map((certification) => (
                <Content
                    subtitleClassName={classes.subtitle}
                    icon={<img src={CertificationIcon} />}
                    key={`${certification.year}${certification.receivedFrom}${certification.certificationName}`}
                    title={<>{`${certification.receivedFrom} ${certification.certificationName}`}</>}
                    description={
                        <>
                            <I18n k={`${T_KEY}.graduated`} /> {certification.year}
                        </>
                    }
                />
            ))}
        </ContentsWrapper>
    </div>
);
